// src/contexts/GalardonesContext.js
// Carga cn_galardones una vez y provee resolveGalardon(candidatura)
// para resolver el nombre localizado desde galardonId.
import { createContext, useContext, useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useLang } from '../i18n';

const Ctx = createContext({ galardones: [], resolveGalardon: c => c?.galardon || '' });
export const useGalardones = () => useContext(Ctx);

function nombre(obj, lang) {
  if (!obj) return '';
  if (typeof obj === 'string') return obj;
  return obj[lang] || obj.en || obj.es || '';
}

export function GalardonesProvider({ children }) {
  const [galardones, setGalardones] = useState([]);
  const { lang } = useLang();

  useEffect(() => {
    return onSnapshot(collection(db, 'cn_galardones'), snap => {
      setGalardones(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
  }, []);

  const resolveGalardon = (candidatura) => {
    if (!candidatura) return '';
    if (candidatura.galardonId) {
      const g = galardones.find(x => x.id === candidatura.galardonId);
      if (g) return nombre(g.nombre, lang);
    }
    // Fallback: campo galardon almacenado (idioma del creador)
    return candidatura.galardon || '';
  };

  return (
    <Ctx.Provider value={{ galardones, resolveGalardon }}>
      {children}
    </Ctx.Provider>
  );
}
